import { render, staticRenderFns } from "./HiveIcon.vue?vue&type=template&id=1935c33d&"
import script from "./HiveIcon.vue?vue&type=script&lang=js&"
export * from "./HiveIcon.vue?vue&type=script&lang=js&"
import style0 from "./HiveIcon.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports